import createRefdataApi from "../createRefdataApi";
import { ApolloClient } from "@apollo/client";
import {
  GetSharedDrivesQuery,
  GetSharedDrivesDocument,
} from "./query.hotchoc.generated";
import { hotChocolateClientContext } from "~/Apollo";
import { SharedDrive } from "~/gql/types2";

async function sharedDriveFetcher(client: ApolloClient<any>) {
  const result = await client.query<GetSharedDrivesQuery>({
    query: GetSharedDrivesDocument,
    context: hotChocolateClientContext,
  });

  return result.data?.projectFolders?.drives as SharedDrive[];
}

const api = createRefdataApi(sharedDriveFetcher, "shared drives");

export const SharedDrivesRefDataContext = api.Provider;
export const useSharedDrivesAsync = api.useDataAsync;
export const useSharedDrives = api.useData;
export const useInvalidateSharedDrives = api.useInvalidate;
